
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic17On as ObiHydraulic17OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-17-on.js';
 
 
 

 
 export const ObiHydraulic17On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-17-on',
   elementClass: ObiHydraulic17OnElement,
   events: {
     
   }
  });
 
 